// extracted by mini-css-extract-plugin
export default {"logo":"SlingshotLayout_logo__POmxT","brandLine":"SlingshotLayout_brandLine__KEShr","wider":"SlingshotLayout_wider__2LFyz","wrapper":"SlingshotLayout_wrapper__JjLWm"};